import { render, staticRenderFns } from "./earth.vue?vue&type=template&id=640e8d3c&scoped=true"
import script from "./earth.vue?vue&type=script&lang=js"
export * from "./earth.vue?vue&type=script&lang=js"
import style0 from "./earth.vue?vue&type=style&index=0&id=640e8d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e8d3c",
  null
  
)

export default component.exports